import { BANNER_TYPES } from '@sravni/react-advertisement';

export const DEFAULT_BORDERED_BANNERS = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE];
